import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Client, StompSubscription, Message } from '@stomp/stompjs';
import { EnvironmentService } from './environment.service';

import { NotificationType } from '../model/notification.model';
import { AuthService } from '../app/auth/auth.service';

export interface WsMessage {
  message: NotificationType;
  timestamp: Date;
}

@Injectable({
  providedIn: 'root',
})
export class WebSocketService implements OnDestroy {
  private stompClient: Client | null = null;
  private subscription: StompSubscription | null = null;

  private _notifications$ = new BehaviorSubject<WsMessage | undefined>(
    undefined
  );
  public notifications$ = this._notifications$.asObservable();

  constructor(
    private envService: EnvironmentService,
    private authService: AuthService
  ) {
    this.connect();
  }

  private connect(): void {
    this.stompClient = new Client({
      brokerURL: `${this.envService.apiUrl.replace(/^http/, 'ws')}/ws`,
      reconnectDelay: 5000,
      // Rilegge il token ad ogni (ri)connessione: dopo un refresh la riconnessione
      // usa il token aggiornato invece di quello catturato alla prima connect.
      beforeConnect: () => {
        this.stompClient!.connectHeaders = {
          Authorization: `Bearer ${this.authService.getToken()}`,
        };
      },
    });

    this.stompClient.onConnect = () => {
      this.subscription =
        this.stompClient?.subscribe(
          '/user/queue/notifications',
          (message: Message) => this.onMessageReceived(message)
        ) ?? null;
    };

    this.stompClient.onStompError = (frame) => {
      console.error('Broker reported error: ' + frame.headers['message']);
      console.error('Additional details: ' + frame.body);
    };

    this.stompClient.activate();
  }

  private onMessageReceived(message: Message) {
    const notification: WsMessage = {
      message: JSON.parse(message.body),
      timestamp: new Date(),
    };
    // console.log('Received message: ', notification);
    if (notification) {
      this._notifications$.next(notification);
    }
  }

  disconnect(): void {
    this.subscription?.unsubscribe();
    this.stompClient?.deactivate();
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
